import { render } from "./ShipmentSummary.vue?vue&type=template&id=d7586dfc"
import script from "./ShipmentSummary.vue?vue&type=script&lang=js"
export * from "./ShipmentSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__